// ⚠️ GENERATED COPY — DO NOT EDIT.
// Source: shared/ui/journey/DoneScreen.tsx — edit there, then run: bash scripts/sync_shared_code.sh
// CI verifies these copies match the source (sync_shared_code.sh --check).
import React, { useEffect } from "react";
import { J, ensureJourneyKeyframes, motionOk } from "./journeyTheme";

/**
 * The closing screen: a check that pops in, a title, and what happened.
 * Ported from the approved plan-holder prototype (Main.dc.html, done screen).
 */

export interface DoneScreenProps {
  title: string;
  body?: string;
  steps?: Array<{ label: string; when?: string }>;
  footer?: string;
  children?: React.ReactNode;
}

const Check = ({ size, weight }: { size: number; weight: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={weight}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12l5 5L20 7" />
  </svg>
);

export default function DoneScreen({ title, body, steps, footer, children }: DoneScreenProps) {
  useEffect(() => {
    ensureJourneyKeyframes();
  }, []);
  const animate = motionOk();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 14,
        paddingTop: 28,
        flex: "1 1 0",
        animation: animate ? "pj-fadeUp .38s ease both" : undefined,
      }}
    >
      <div
        style={{
          width: 84,
          height: 84,
          borderRadius: "50%",
          background: J.sage,
          color: J.white,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 10px 28px rgba(107,156,142,.35)",
          animation: animate ? "pj-pop .5s cubic-bezier(.2,.8,.2,1) both" : undefined,
        }}
      >
        <Check size={40} weight="3" />
      </div>
      <h1 style={{ margin: "6px 0 0", fontSize: 26, lineHeight: 1.2, fontWeight: 700, color: J.ink }}>{title}</h1>
      {body ? (
        <p style={{ margin: 0, fontSize: 15, lineHeight: 1.5, color: J.body, maxWidth: 300 }}>{body}</p>
      ) : null}
      {steps && steps.length > 0 ? (
        <ul
          style={{
            listStyle: "none",
            width: "100%",
            boxSizing: "border-box",
            background: J.white,
            borderRadius: J.radiusCard,
            padding: "6px 16px",
            margin: "8px 0 0",
            boxShadow: J.shadow,
            textAlign: "left",
          }}
        >
          {steps.map((s, i) => (
            <li
              key={`${i}-${s.label}`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "11px 0",
                // The prototype rules every row; the first rule sits against
                // the card's own top padding, so it reads as a hairline inset.
                borderTop: `1px solid ${J.hairline}`,
              }}
            >
              <div
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  background: J.sage,
                  color: J.white,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: "0 0 22px",
                }}
              >
                <Check size={12} weight="3.2" />
              </div>
              <div style={{ flex: "1 1 0", fontSize: 14.5, fontWeight: 600, color: J.ink }}>{s.label}</div>
              {s.when ? <div style={{ fontSize: 12, color: J.muted }}>{s.when}</div> : null}
            </li>
          ))}
        </ul>
      ) : null}
      {children}
      {footer ? (
        <div style={{ marginTop: "auto", fontSize: 13, color: J.muted, paddingTop: 10 }}>{footer}</div>
      ) : null}
    </div>
  );
}
